import React from "react";

function Footer() {
  return (
    <>
    {/* Upper Background Image */}
    <div className="relative">
      {/* <img className="" src="https://mars-metcdn-com.global.ssl.fastly.net/content/uploads/sites/101/2019/04/30174046/footer-background.png" /> */}
      <div className="absolute text-xl top-0">Text</div>
    </div>



      {/* Lower Bar   */}
      <div className="w-full bg-black hidden md:block">
        <div className="w-full md:w-10/12 lg:w-7/12 mx-auto">
          <div className="flex flex-row justify-between py-2">
            {/* Left */}
            <div className="flex flex-row items-center">
              <div className="mr-5 text-xs text-white cursor-pointer tracking-widest">
                © Newspaper WordPress Theme by TagDiv
              </div>
            </div>

            {/* Right */}
            <div className="flex flex-row items-center">
              <div className="mr-5 text-xs-s text-white cursor-pointer tracking-widest">
                Disclaimer
              </div>
              <div className="mr-5 text-xs-s text-white cursor-pointer tracking-widest">
                Privacy
              </div>
              <div className="mr-5 text-xs-s text-white cursor-pointer tracking-widest">
                Advertisement
              </div>
              <div className="mr-5 text-xs-s text-white cursor-pointer tracking-widest">
                Contact us
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Footer;
